import { useMemo } from 'react';
import { EnterpriseLocation } from 'models/Enterprises';
import { sortByName } from 'utils';

export default function useMemberLocations(
  memberLocations: EnterpriseLocation[] = [],
) {
  const sortedMemberLocations = useMemo(
    () => sortByName(memberLocations),
    [memberLocations],
  );

  const memberLocationsOptions = useMemo(
    () =>
      sortedMemberLocations.map(({ _id, name }) => ({
        value: _id,
        label: name,
      })),
    [sortedMemberLocations],
  );

  return { sortedMemberLocations, memberLocationsOptions };
}
